module.exports = __webpack_public_path__ + "static/media/JO.64894ec4.svg";